import { IChoiceFilters } from '@/interfaces/choice.interfaces';

const isFiltersSelected = (filtersChoice: IChoiceFilters) =>
  !!Object.keys(filtersChoice).length;

export default isFiltersSelected;
